import { useContext, useEffect, useState } from "react";
import {
  emailOption,
  garageoption,
  robotsOption,
  mainUrl,
} from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useAddGarage = () => {
  const { t } = useLocale();
  const { navigateTo } = useContext(NavigatorContext);
  const { fetchByAttr, save, update } = useService("Data", "garage");
  const { getUsers } = useService("User");
  const { setTitle } = useService("Meta");
  const { showAlert, isEmpty, generateUID, slugify } = useService("Misc");
  const { urlToSplitData, getLocationData } = useService("Router");
  const keywordOptions = [],
    categoryOptions = [],
    tagOptions = [];
  const [activeRobotsIndex, setactiveRobotsIndex] = useState<number>(0);
  const [activeStatusIndex, setactiveStatusIndex] = useState<number>(0);
  const [activeEmailIndex, setactiveEmailIndex] = useState<number>(0);
  const [image, setimage] = useState<string>("[]");
  const [uid, setuid] = useState<string>("");
  const [renderSlug, setrenderSlug] = useState<boolean>(true);
  const [mode, setmode] = useState<"add" | "edit" | "view">("add");
  const [title, settitle] = useState<string>("");
  const [slug, setslug] = useState<string>("");
  const [address, setaddress] = useState<string>("");
  const [businessinformation, setbusinessinformation] = useState("");
  const [css, setcss] = useState<string>("");
  const [js, setjs] = useState<string>("");
  const [canonical, setcanonical] = useState<string>("");
  const [robots, setrobots] = useState<string>("");
  const [metaDescription, setmetaDescription] = useState<string>("");
  const [metaKeyword, setmetaKeyword] = useState(null);
  const [metaTitle, setmetaTitle] = useState<string>("");
  const [email, setemail] = useState<string>("");
  const [phoneNumber, setphoneNumber] = useState<string>("");
  const [yearEstablished, setyearEstablished] = useState(new Date());
  const [assignWorkers, setassignWorkers] = useState([]);
  const [status, setstatus] = useState(null);
  const [category, setcategory] = useState(null);
  const [tag, settag] = useState(null);
  const urlData = urlToSplitData(getLocationData().pathname);

  setTitle("Add Garage", "admin");
  useEffect(() => {
    setstatus(garageoption[activeStatusIndex].value);
    if (urlData[3] === "edit") {
      getGarageData({ uid: urlData[4] });
    }
    getUsersData();
  }, []);

  const getUsersData = async () => {
    let tableData = [];
    const result = await getUsers();
    if (result.status) {
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: "No user added yet!" });
      } else {
        result.data.forEach((result) => {
          tableData.push({ label: result.name, value: result.uid });
        });
        setassignWorkers(tableData);
      }
    }
  };

  const getGarageData = async (query) => {
    const result = await fetchByAttr(query);
    if (result.status) {
      const garageData = result.data[0];
      setactiveRobotsIndex(
        robotsOption.findIndex((e) => e.value === garageData.robots)
      );
      setactiveEmailIndex(
        emailOption.findIndex((e) => e.value === garageData.email)
      );
      setactiveStatusIndex(
        garageoption.findIndex((e) => e.value === garageData.status)
      );
      setmetaKeyword(
        isEmpty(garageData.metaKeyword) ? [] : garageData.metaKeyword
      );
      settag(isEmpty(garageData.tag) ? [] : garageData.tag);
      setcategory(isEmpty(garageData.category) ? [] : garageData.category);
      setmetaTitle(garageData.metaTitle);
      settitle(garageData.title);
      setmode("edit");
      setslug(garageData.slug);
      setrenderSlug(false);
      setaddress(garageData.address);
      setbusinessinformation(garageData.businessinformation);
      setcss(garageData.css);
      setjs(garageData.js);
      setcanonical(garageData.canonical);
      setrobots(garageData.robots);
      setmetaDescription(garageData.metaDescription);
      setemail(garageData.email);
      setphoneNumber(garageData.phoneNumber);
      setyearEstablished(new Date(garageData.yearEstablished));
      setstatus(garageData.status);
      setuid(garageData.uid);
      setimage(garageData.image);
    } else showAlert({ type: "error", msg: "No garage added yet!" });
  };

  const addGarage = async (e) => {
    e.preventDefault();
    let error = false,
      errorMsg = "",
      garageObject = {
        title,
        slug,
        address,
        businessinformation,
        css,
        js,
        canonical,
        robots,
        metaDescription,
        metaTitle,
        metaKeyword: JSON.stringify(metaKeyword),
        email,
        phoneNumber,
        yearEstablished,
        status: status.value,
        category: JSON.stringify(category),
        tag: JSON.stringify(tag),
        image,
        uid: mode === "add" ? generateUID() : uid,
      };
    if (title === "") {
      errorMsg = t("errorMsg.required.title");
      error = true;
    } else if (slug === "") {
      errorMsg = t("errorMsg.required.slug");
      error = true;
    } else if (businessinformation === "") {
      errorMsg = t("errorMsg.required.businessInfo");
      error = true;
    } else if (address === "") {
      errorMsg = t("errorMsg.required.address");
      error = true;
    } else if (email === "") {
      errorMsg = t("errorMsg.required.emailSelect");
      error = true;
    } else if (phoneNumber === "") {
      errorMsg = t("errorMsg.required.mobile");
      error = true;
    } else if (image === "") {
      errorMsg = t("errorMsg.required.image");
      error = true;
    }
    if (!error) {
      if (mode === "add") {
        const result = await save(garageObject);
        if (result.status) {
          showAlert({ type: "success", msg: "Garage added successfully!" });
          navigateTo({ route: "/admin/garage/list" });
        } else showAlert({ type: "error", msg: "Unable to add garage!" });
      } else {
        let data = {
          query: JSON.stringify({ uid }),
          garageData: JSON.stringify(garageObject),
        };
        const result = await update(data);
        if (result.status) {
          showAlert({ type: "success", msg: "Garage updated successfully!" });
          navigateTo({ route: "/admin/garage/list" });
        } else showAlert({ type: "error", msg: "Unable to update garage!" });
      }
    } else showAlert({ type: "error", msg: errorMsg });
  };

  const pageTitle = mode + " Garage";
  if (canonical === "") {
    setcanonical(mainUrl + urlData[2] + "/" + slug);
  }
  let activeRobots = robotsOption[activeRobotsIndex],
    activeEmail = emailOption[activeEmailIndex],
    activeStatus = garageoption[activeStatusIndex];
  if (mode === "edit") {
    garageoption.forEach((e) => {
      if (e.value === status) {
        activeStatus = e;
      }
    });
    robotsOption.forEach((e) => {
      if (e.value === robots) {
        activeRobots = e;
      }
    });
    assignWorkers.forEach((e) => {
      if (e.value === email) {
        activeEmail = e;
      }
    });
  }

  const toggleRenderSlug = () => setrenderSlug(!renderSlug);

  const addTitle = (e) => {
    let tempTitle = e.target.value,
      tempSlug = slug;
    if (renderSlug) {
      tempSlug = slugify(tempTitle);
    }
    settitle(tempTitle);
    setslug(tempSlug);
  };
  return {
    pageTitle,
    addGarage,
    title,
    addTitle,
    slug,
    setslug,
    address,
    setaddress,
    businessinformation,
    css,
    setcss,
    js,
    setjs,
    canonical,
    setcanonical,
    image,
    setimage,
    tagOptions,
    settag,
    tag,
    categoryOptions,
    setcategory,
    category,
    setstatus,
    activeStatus,
    status,
    yearEstablished,
    setyearEstablished,
    setphoneNumber,
    phoneNumber,
    setemail,
    email,
    setbusinessinformation,
    activeRobots,
    setrobots,
    metaDescription,
    setmetaDescription,
    setmetaKeyword,
    metaTitle,
    setmetaTitle,
    keywordOptions,
    metaKeyword,
    renderSlug,
    toggleRenderSlug,
  };
};
